
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thumbnails",
      function () {
        return require("private-next-pages/thumbnails.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/thumbnails"])
      });
    }
  